import React from 'react';

interface TextWithLineBreaksProps {
  id?: string;
  text: string;
  className?: string;
}

const TextWithLineBreaks = ({ id, text, className }: TextWithLineBreaksProps) => {
  const lines = text.split('\n');

  {
    /* 복사하기를 위한 id */
  }
  return (
    <span id={id} className={className}>
      {lines.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index !== lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </span>
  );
};

export default TextWithLineBreaks;
